import { StopPointHelper } from '../../../../helpers/stop-point.helper';
import type { IMunicipality } from '../../../../models/municipality.model';
import type { IStopPoint } from '../../../../models/stop-point.model';
import { StopAreaApiModel } from './stop-area.api-model';

export class StopPointApiModel {
  public static mapToBusinessModel(apiModel: StopPointApiModel): IStopPoint {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      platform: apiModel.platform,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      municipality: apiModel.municipality,
      stopArea: apiModel.stopArea ? StopAreaApiModel.mapToBusinessModel(apiModel.stopArea) : undefined,
      stopPointType: StopPointHelper.mapToStopPointType(apiModel.stopPointType),
    };
  }

  public gid!: string;
  public name!: string;
  public platform?: string;
  public latitude?: number;
  public longitude?: number;
  public municipality?: IMunicipality;
  public stopArea?: StopAreaApiModel;
  public stopPointType!: string;
}
